module.exports = {"130606001":"和平里街道","130606002":"五四路街道","130606003":"西关街道","130606004":"中华路街道","130606005":"东关街道","130606006":"联盟街道","130606007":"红星街道","130606008":"裕华街道","130606009":"永华街道","130606010":"南关街道","130606100":"百楼镇","130606200":"韩庄乡","130606201":"东金庄乡","130606203":"杨庄乡","130606204":"南大园乡","130606205":"焦庄乡","130606206":"五尧乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130606.json
// module id = 240
// module chunks = 0